<template>

</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Doc/Footer.vue